<!-- <h3>All Notifications</h3>

<table class="table table-bordered">
  <thead>
    <tr>
      <th>Subject</th>
      <th>Number</th>
      <th>Date</th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let item of notifications">
      <td>{{ item.subject }}</td>
      <td>{{ item.number }}</td>
      <td>{{ item.date }}</td>
    </tr>
  </tbody>
</table> -->

<div class="container py-4">

  <div class="card shadow-sm border-0">

    <!-- HEADER -->
    <div class="card-header bg-white d-flex justify-content-between align-items-center flex-wrap gap-2">
      <div>
        <h4 class="mb-0 fw-semibold">{{ pageTitle }}</h4>
        <small class="text-muted">Department of Cooperation Notifications</small>
      </div>
    </div>
    <div class="container py-4">

<div class="container py-4">

  <!-- Title -->
  <div class="mb-4">
    <h4 class="fw-semibold mb-1">
      Departmental Notifications
    </h4>
    <p class="text-muted mb-0">
      Published in H.P. Govt. Gazette
    </p>
  </div>

  <!-- GRID -->
  <div class="row g-4">

    <!-- Reports Card -->
    <div class="col-md-4">
      <div class="card h-100 shadow-sm border-0 hover-card">

        <div class="card-body">

          <div class="d-flex align-items-center mb-3">
            <div class="icon-box bg-primary text-white">
              <i class="fa fa-file-text"></i>
            </div>
            <h6 class="ms-2 mb-0 fw-semibold">Reports & Info</h6>
          </div>

          <ul class="list-unstyled mb-0">
            <li><a routerLink="#" class="link-item">Administrative Report</a></li>
            <li><a routerLink="#" class="link-item">Properties of Officials</a></li>
            <li><a routerLink="#" class="link-item">Training Manual</a></li>
          </ul>

        </div>

      </div>
    </div>

    <!-- Establishment Card -->
    <div class="col-md-4">
      <div class="card h-100 shadow-sm border-0 hover-card">

        <div class="card-body">

          <div class="d-flex align-items-center mb-3">
            <div class="icon-box bg-success text-white">
              <i class="fa fa-building"></i>
            </div>
            <h6 class="ms-2 mb-0 fw-semibold">Establishment</h6>
          </div>

          <ul class="list-unstyled mb-0">
            <li><a routerLink="#" class="link-item">R&P Rules & Seniority</a></li>
            <li><a routerLink="#" class="link-item">Transfer Orders</a></li>
            <li><a routerLink="#" class="link-item">Promotion Orders</a></li>
          </ul>

        </div>

      </div>
    </div>

    <!-- Committee Card -->
    <div class="col-md-4">
      <div class="card h-100 shadow-sm border-0 hover-card">

        <div class="card-body">

          <div class="d-flex align-items-center mb-3">
            <div class="icon-box bg-danger text-white">
              <i class="fa fa-users"></i>
            </div>
            <h6 class="ms-2 mb-0 fw-semibold">Committees</h6>
          </div>

          <ul class="list-unstyled mb-0">
            <li>
               <a href="../../assets/notificationDocs/Sexual Harassment Jun.pdf" target="_blank"  class="link-item">
          Sexual Harassment Committee 
        </a>
              <!-- <a routerLink="" class="link-item">Sexual Harassment Committee</a> -->
            </li>
          </ul>

        </div>

      </div>
    </div>

  </div>

</div>

</div>

  <div class="card-body">

  <!-- SEARCH -->
  <div class="row mb-3">
    <div class="col-md-6">
      <input type="text"
             class="form-control"
             placeholder="Search notifications...">
    </div>
  </div>

  <!-- TABLE -->
  <div class="table-responsive">

    <table class="table table-hover align-middle">

      <thead class="table-light">
        <tr>
          <th>Title</th>
          <th style="width:120px;">Date</th>
          <th style="width:80px;" class="text-center">New</th>
          <th style="width:100px;" class="text-center">Action</th>
        </tr>
      </thead>

      <tbody>

        <tr *ngFor="let n of notifications">

          <!-- TITLE -->
          <td>
            <div class="fw-semibold text-dark">
              {{ n.title }}
            </div>
          </td>

          <!-- DATE -->
          <td class="text-muted">
            {{ n.date }}
          </td>

          <!-- NEW BADGE -->
          <td class="text-center">
            <span *ngIf="n.isNew" class="badge bg-danger">
              NEW
            </span>
          </td>

          <!-- ACTION -->
          <td class="text-center">

            <a *ngIf="n.link"
               [href]="n.link"
               target="_blank"
               class="btn btn-sm btn-outline-primary"   (click)="downloadFile(n.link)">
              View
            </a>

            <span *ngIf="!n.link" class="text-muted">
              No File
            </span>

          </td>

        </tr>

      </tbody>

    </table>

  </div>

</div>

  </div>

</div>